import { render, staticRenderFns } from "./SignupInit.vue?vue&type=template&id=3fdffbcc&"
import script from "./SignupInit.vue?vue&type=script&lang=js&"
export * from "./SignupInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports